import { mapState } from "vuex";
import { Toast, Icon, Dialog, PullRefresh, ActionSheet } from "vant";
import { getAreas, getAppIdCache, getDefaultDelivery } from "@/api/app";
import { guid, numFormat } from "@/utils/utils";
import { getConfirmOrder } from "@/api/groupBuying";
import { editDelivery2 } from "@/api/addr/addr";
import common from "../../../assets/js/common";
import {
  submitOrder,
  compareAddr,
  updateEnterprise,
  getEnterpriseList,
  toFreightAmountNew2
} from "@/api/order/confirmOrder";

export default {
  components: {
    Icon,
    PullRefresh,
    ActionSheet
  },
  data() {
    return {
      id: "",
      data: {},
      checked: true,
      loading: false,
      numFormat,
      priceType: "1",
      goodsList: [],
      isInNxinApp: false,
      areasVisible: false,
      areasOptions: [],
      areasCascader: "",
      delivery: {
        tel: "",
        addr: "",
        name: "",
        areaId: "",
        cityId: "",
        areaAxis: "",
        isdefault: 1,
        deliveryId: "",
        provinceId: "",
        areaFullName: ""
      },
      totalAmount: "0.00",
      freightCharge: "0.00",
      enterprise: {},
      enterpriseList: [],
      depositVisible: false,
      isSupportInvoice: 0,
      groupBuyingInvoice: {
        isZzInvoice: "0"
      },
      enterpriseListVisible: false,
      memo: ""
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.app.userInfo,
      userIdentity: state => state.app.userIdentity
    })
  },
  created() {
    const {
      query: { id, priceType }
    } = this.$route;

    if (!common.isLogin(this.userInfo.id)) {
      return;
    }

    if (!id) {
      Dialog.alert({
        message: "活动已结束"
      }).then(() => {
        this.$router.push("/index");
      });
      return;
    }

    if (!isInNxinApp()) {
      getEnterpriseList().then(res => {
        const { data } = res;
        this.enterpriseList = data;

        const [enterprise = {}] = data.filter(item => item.IsDefault);

        if (enterprise.ID) {
          this.enterprise = enterprise;
        } else {
          this.enterprise = {};
        }
      });
    } else {
      this.isInNxinApp = true;
    }

    this.id = id;
    this.priceType = priceType;

    getAreas({
      parentId: 0
    }).then(res => {
      const { code, data } = res;
      if (code == "0") {
        this.areasOptions = data.map(item => {
          if (item.end) {
            return item;
          }
          return {
            ...item,
            children: []
          };
        });
      }
    });

    const groupBuyingInvoice = window.localStorage.getItem("groupBuyingInvoice");
    if (groupBuyingInvoice) {
      const { data } = JSON.parse(groupBuyingInvoice);

      this.groupBuyingInvoice = data;
    }

    // console.log("data", data.name);

    this.loadData();
  },
  beforeDestory() {
    Toast.clear();
  },
  methods: {
    loadData() {
      const { id, priceType } = this;
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });

      Promise.all([getConfirmOrder({ id }), getDefaultDelivery()])
        .then(([orderRes, deliveryRes]) => {
          /* 订单信息 */
          const { data = {} } = orderRes;

          /* 是否支持开发票 */
          this.isSupportInvoice = data.isSupportInvoice;
          this.groupBuyingInvoice = {
            ...this.groupBuyingInvoice,
            isZzInvoice: data.isZzInvoice
          };

          /*  已删除 */
          if (orderRes.activityStatus == 3) {
            this.$router.push("/groupBuying/over");
            return;
          }
          if (data.activityStatus == 2) {
            this.$router.push(`/groupBuying?id=${id}`);
            return;
          }
          document.title = data.name;

          this.goodsList = data.combinationOrderGoodsInfoVoList.map(item => {
            let amount = item.singlePrice;
            const { originalPrice, goodsLadderPriceList } = item;
            if (priceType == "1") {
              amount = goodsLadderPriceList[0].price;
            } else if (priceType == "3") {
              const totalCount = Number(item.joinCombinationOrderTotalCount);
              if (totalCount >= Number(goodsLadderPriceList[0].minQuantity)) {
                const [priceObj] = JSON.parse(JSON.stringify(item.goodsLadderPriceList))
                  .reverse()
                  .filter(priceItem => totalCount >= Number(priceItem.minQuantity));
                if (priceObj && priceObj.price) {
                  amount = priceObj.price;
                }
              } else {
                amount = originalPrice;
              }
            }
            return {
              ...item,
              amount,
              quantity: item.startQuantity || 1,
              showTips: false,
              isMaxLevel: false,
              totalSpare: 0,
              futureAmount: 0,
              futurePrices:
                (item.goodsLadderPriceList[1] && item.goodsLadderPriceList[1].price) || ""
            };
          });

          this.data = data;
          this.compute();

          /* 默认地址 */
          const { memberDelivery = {} } = deliveryRes;
          if (memberDelivery && memberDelivery.deliveryId) {
            this.delivery = memberDelivery;
          }

          this.compareAddrChange();
        })
        .finally(() => {
          Toast.clear();
          this.loading = false;
        });
    },
    enterpriseChange(id) {
      updateEnterprise({ enterpriseId: id }).then(res => {
        if (res.data) {
          this.$router.go(0);
        }
      });
    },
    goDetail(goodsId) {
      this.$router.push(`/goodDetails/${goodsId}`);
    },
    areasChange({ value, selectedOptions, tabIndex }) {
      const { end, children = [] } = selectedOptions[tabIndex];
      const loop = (loopData, loopChildren) => {
        if (loopData && loopData.length) {
          const index = loopData.findIndex(item => item.id == value);
          if (index === -1) {
            loopData.forEach(item => {
              loop(item.children, loopChildren);
            });
          } else {
            loopData[index].children = loopChildren;
            if (tabIndex == 2) {
              const lastObj = {
                id: value,
                name: "暂不选择",
                end: true
              };
              loopData[index].children.push(lastObj);
            }
          }
        }
      };
      if (end) {
        const filterOptions = selectedOptions.filter(option => option.name != "暂不选择");
        const last = filterOptions[filterOptions.length - 1];
        this.areasVisible = false;
        this.delivery.areaAxis = `$${filterOptions.map(option => option.id).join("$")}`;
        this.delivery.cityId = (filterOptions[1] && filterOptions[1].id) || "";
        this.delivery.areaId = last.id;
        this.delivery.provinceId = filterOptions[0].id;
        this.delivery.areaFullName = filterOptions.map(option => option.name).join("-");

        editDelivery2(this.delivery).then((res = {}) => {
          const { data: deliveryData } = res;
          this.delivery = deliveryData;
          this.$nextTick(() => {
            this.freightAmount();
            this.compareAddrChange();
          });
        });
      } else if (!children.length) {
        getAreas({ parentId: value }).then(res => {
          const { code, data } = res;
          if (code == "0") {
            const areasOptions = JSON.parse(JSON.stringify(this.areasOptions));
            loop(areasOptions, data);
            this.areasOptions = areasOptions;
          }
        });
      }
    },
    quantityPlus(index) {
      const { priceType, delivery, goodsList } = this;
      const {
        amount,
        quantity,
        originalPrice,
        startQuantity,
        maxQuantity,
        currQuantity,
        goodsLadderPriceList,
        joinCombinationOrderTotalCount = 0
      } = goodsList[index];

      if (!delivery.deliveryId) {
        Toast("请选择收货地址");
        return;
      }

      if (priceType == 3) {
        let amountTem = amount;
        let quantityTem = Number(quantity) + 1;

        if (quantityTem >= 999999) {
          quantityTem = 999999;
        } else if (quantityTem < Number(startQuantity)) {
          quantityTem = Number(startQuantity);
        }

        const totalCount = quantityTem + Number(joinCombinationOrderTotalCount);
        if (totalCount >= Number(goodsLadderPriceList[0].minQuantity)) {
          amountTem = JSON.parse(JSON.stringify(goodsLadderPriceList))
            .reverse()
            .filter(priceItem => totalCount >= Number(priceItem.minQuantity))[0].price;
        } else {
          amountTem = originalPrice;
        }

        this.$set(this.goodsList, index, {
          ...this.goodsList[index],
          amount: amountTem,
          quantity: quantityTem
        });

        this.$nextTick(() => {
          this.compute();
        });
        return;
      }

      if (Number(quantity) >= Number(currQuantity)) {
        Toast("商品已卖完");
        return;
      }

      if (Number(quantity) >= Number(maxQuantity)) {
        Toast("已到最大购买量");
        return;
      }

      let min = Number(startQuantity);

      if (priceType == "1") {
        min = Number(goodsLadderPriceList[0].minQuantity);
      }

      this.$set(this.goodsList, index, {
        ...this.goodsList[index],
        quantity: Number(quantity) + 1 < min ? min : Number(quantity) + 1
      });

      this.$nextTick(() => {
        this.compute();
      });
    },
    quantityMinus(index) {
      const { goodsList, priceType } = this;
      const {
        amount,
        quantity,
        originalPrice,
        startQuantity,
        goodsLadderPriceList,
        joinCombinationOrderTotalCount = 0
      } = goodsList[index];
      if (priceType == 1) {
        if (Number(quantity) <= Number(goodsLadderPriceList[0].minQuantity)) {
          this.$set(this.goodsList, index, {
            ...this.goodsList[index],
            quantity: 0
          });

          this.$nextTick(() => {
            this.compute();
          });
          return;
        }

        this.$set(this.goodsList, index, {
          ...this.goodsList[index],
          quantity: quantity - 1
        });

        this.$nextTick(() => {
          this.compute();
        });
        return;
      }

      if (priceType == 3) {
        let amountTem = amount;
        let quantityTem = Number(quantity) - 1;
        if (Number(quantity) - 1 < Number(startQuantity)) {
          quantityTem = 0;
        }

        const totalCount = quantityTem + Number(joinCombinationOrderTotalCount);
        if (totalCount >= Number(goodsLadderPriceList[0].minQuantity)) {
          amountTem = JSON.parse(JSON.stringify(goodsLadderPriceList))
            .reverse()
            .filter(priceItem => totalCount >= Number(priceItem.minQuantity))[0].price;
        } else {
          amountTem = originalPrice;
        }

        this.$set(this.goodsList, index, {
          ...this.goodsList[index],
          amount: amountTem,
          quantity: quantityTem
        });

        this.$nextTick(() => {
          this.compute();
        });
        return;
      }

      if (Number(quantity) <= Number(startQuantity)) {
        this.$set(this.goodsList, index, {
          ...this.goodsList[index],
          quantity: 0
        });

        this.$nextTick(() => {
          this.compute();
        });
        return;
      }

      this.$set(this.goodsList, index, {
        ...this.goodsList[index],
        quantity: quantity - 1
      });

      this.$nextTick(() => {
        this.compute();
      });
    },
    quantityChange(index) {
      this.$nextTick(() => {
        const { priceType, goodsList } = this;
        const {
          amount,
          quantity,
          startQuantity,
          maxQuantity,
          originalPrice,
          goodsLadderPriceList,
          joinCombinationOrderTotalCount = 0
        } = goodsList[index];
        if (priceType == 3) {
          let amountTem = Number(amount);
          let quantityTem = Number(quantity);
          if (quantityTem >= 999999) {
            quantityTem = 999999;
          } else if (quantityTem < Number(startQuantity)) {
            quantityTem = 0;
          }
          const totalCount = quantityTem + Number(joinCombinationOrderTotalCount);
          if (totalCount >= Number(goodsLadderPriceList[0].minQuantity)) {
            amountTem = JSON.parse(JSON.stringify(goodsLadderPriceList))
              .reverse()
              .filter(priceItem => totalCount >= Number(priceItem.minQuantity))[0].price;
          } else {
            amountTem = originalPrice;
          }

          this.$set(this.goodsList, index, {
            ...this.goodsList[index],
            amount: amountTem,
            quantity: quantityTem
          });
          this.$nextTick(() => {
            this.compute();
          });
          return;
        }

        if (Number(quantity) >= Number(maxQuantity)) {
          this.$set(this.goodsList, index, {
            ...this.goodsList[index],
            quantity: maxQuantity
          });
          this.$nextTick(() => {
            this.compute();
          });
          return;
        }

        if (priceType == 1) {
          if (Number(quantity) <= Number(goodsLadderPriceList[0].minQuantity)) {
            this.$set(this.goodsList, index, {
              ...this.goodsList[index],
              quantity: goodsLadderPriceList[0].minQuantity
            });
          }
          this.$nextTick(() => {
            this.compute();
          });
          return;
        }

        if (Number(quantity) <= Number(startQuantity)) {
          this.$set(this.goodsList, index, {
            ...this.goodsList[index],
            quantity: startQuantity
          });
        }
        this.$nextTick(() => {
          this.compute();
        });
      });
    },
    priceSplit(price) {
      if (price) {
        return String(price).split(".");
      }
      return ["-", "-"];
    },
    submitOrders() {
      const {
        id,
        checked,
        delivery = {},
        goodsList,
        data: { shopId, shippingType, depositRatio, paymentTimeLimit },
        priceType,
        totalAmount,
        memo
      } = this;

      if (shippingType == 2) {
        Toast("暂不支持该区域配送，不支持下单该商品");
        return;
      }

      if (!delivery.name) {
        Toast("收货人不能为空");
        return;
      }
      if (!delivery.tel) {
        Toast("联系方式不能为空");
        return;
      }
      if (!delivery.areaFullName) {
        Toast("收货地址不能为空");
        return;
      }
      if (!delivery.addr) {
        Toast("详细地址不能为空");
        return;
      }
      const selectGoods = goodsList.filter(item => item.quantity);
      if (!selectGoods.length) {
        Toast("商品数量不能为空");
        return;
      }

      if (!checked) {
        Toast("阅读并同意《活动玩法及定金规则》");
        return;
      }

      const submitOrdersForm = () => {
        editDelivery2(delivery).then((res = {}) => {
          const { data: deliveryData } = res;
          this.delivery = deliveryData;
          const order = [
            {
              payment: "1",
              shopId,
              logistics: "1",
              deliveryId: deliveryData.deliveryId,
              deliveryAreaId: deliveryData.areaAxis,
              combinationOrderId: id,
              combinationOrderType: priceType == 3 ? 2 : undefined,
              orderCartEntity: selectGoods.map(item => ({
                goodsId: item.goodsId,
                goodsQuantity: item.quantity,
                fromShopId: shopId,
                freightTemplateId: item.shopFreightTemplateId,
                transMode: "",
                transModeType: "",
                shareBoId: "0",
                goodsName: item.goodsName,
                goodsPicUrl: item.goodsMainImgUrl,
                goodsPrice: item.quantity
              })),
              memo
            }
          ];
          if (
            this.isSupportInvoice == 1 &&
            this.groupBuyingInvoice &&
            this.groupBuyingInvoice.name
          ) {
            const invoiceInfo = this.groupBuyingInvoice;
            order[0].orderInvoice = {
              issueType: invoiceInfo.issueType,
              receipt: invoiceInfo.name,
              type: invoiceInfo.type,
              invoicetitleType: invoiceInfo.invoicetitleType,
              taxRegistrationNumber: invoiceInfo.code,
              bankAccount: invoiceInfo.bankCode,
              bankOfDeposit: invoiceInfo.bankName,
              companyAddr: invoiceInfo.addr,
              companyTel: invoiceInfo.tel
            };
          }

          submitOrder({
            order: JSON.stringify(order)
          })
            .then(orderRes => {
              console.log("submitOrder", JSON.stringify(orderRes));
              const { msg, code, data } = orderRes;
              if (code != 0) {
                Toast.clear();
                Dialog.alert({
                  message: msg
                });
                return;
              }
              const { VUE_APP_SC } = process.env;
              if (data.result.success) {
                if (data.result.errorcode == 0) {
                  // 一个订单跳转收银台
                  if (data.isSecondReview) {
                    Dialog.alert({
                      message: "该订单需要企联网二次审核，请确认订单无误后点击“去支付”发起支付申请"
                    }).then(() => {
                      window.location.href = `${VUE_APP_SC}mob/order/person/orderListNew.do?type=1`;
                    });
                    return;
                  }
                  if (!data.allowPayment) {
                    Dialog.alert({
                      message: "您没有支付权限"
                    }).then(() => {
                      window.location.href = `${VUE_APP_SC}mob/order/person/orderListNew.do?type=1`;
                    });
                  } else {
                    const url = `${VUE_APP_SC}mob/payment/chectout/cpCheckout.do`;
                    const ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                      const retUrl = `${url}?orderId=${data.orderId}`;
                      wx.miniProgram.getEnv(wxRes => {
                        if (wxRes.miniprogram) {
                          // 跳转到小程序页面获取openId
                          const uuid = guid();
                          wx.miniProgram.navigateTo({
                            url: `/pages/middleTrans/middleTrans?uuid=${uuid}&retUrl=${encodeURIComponent(
                              retUrl
                            )}`,
                            complete() {
                              console.log("跳转到news页面complete");
                              // 跳转小程序失败后的处理
                              setTimeout(() => {
                                getAppIdCache(uuid)
                                  .then(cacheRes => {
                                    if (cacheRes.data) {
                                      Toast.clear();
                                      console.log("成功");
                                    } else {
                                      window.location.href = `${url}?orderId=${
                                        data.orderId
                                      }&wxsmallTage=1`;
                                    }
                                  })
                                  .catch(() => {
                                    window.location.href = `${url}?orderId=${
                                      data.orderId
                                    }&wxsmallTage=1`;
                                  });
                              }, 3000);
                            }
                          });
                        } else {
                          window.location.href = `${url}?orderId=${data.orderId}&isInside=1`;
                        }
                      });
                    } else {
                      window.location.href = `${url}?orderId=${data.orderId}`;
                    }
                  }
                } else if (data.result.errorcode == 1) {
                  // 拆单 跳转订单列表页
                  window.location.href = `${VUE_APP_SC}mob/order/person/orderListNew.do?type=1`;
                } else if (data.result.errorcode == 6) {
                  // 待确认
                  window.location.href = `${VUE_APP_SC}mob/order/person/orderListNew.do?type=0`;
                } else if (data.result.errorcode == 3) {
                  console.log("代下单 跳转订单列表页");
                  // //代下单 跳转订单列表页
                  // if ($("#isNew").val() == 1) {
                  //   $(".p_loding").hide();
                  //   // 去掉代客下单进货车
                  //   sessionStorage.removeItem("customerRecommendShopCheckGoods");
                  //   // mui.toast("下单成功，已发送短信通知");
                  //   mui.toast("下单成功");
                  //   setTimeout(function () {
                  //     let version = $("#version").val();
                  //     $.jumpTo(
                  //       `/mobRecode/order/queryAgentOrderNew.do?version=${version}`,
                  //       {},
                  //       { method: "post" }
                  //     );
                  //   }, 2000);
                  // } else {
                  //   $.jumpTo("/mobRecode/order/queryAgentOrder.do", {}, { method: "post" });
                  // }
                } else if (data.result.errorcode == 5) {
                  // 鸡蛋订单 保证金充值跳转
                  const dataUrl = `${data.url}/margin/toRecharge.do`;
                  const action = dataUrl.indexOf("http") >= 0 ? dataUrl : `${VUE_APP_SC}${dataUrl}`;
                  const form = $(`
                    <form id="groupBuyingForm" action=${action} method="post" target="_self">
                      <input type="hidden" name="goodsId" value="${data.req.goodsId}" />
                      <input type="hidden" name="bizId" value="${data.req.bizId}" />
                      <input type="hidden" name="bizIdType" value="${data.req.bizIdType}" />
                      <input type="hidden" name="boId" value="${data.req.boId}" />
                      <input type="hidden" name="userType" value="${data.req.userType}" />
                      <input type="hidden" name="operatorBoId" value="${data.req.operatorBoId}" />
                      <input type="hidden" name="systemId" value="${data.req.systemId}" />
                      <input type="hidden" name="orderId" value="${data.req.orderId}" />
                      <input type="hidden" name="resultURL" value="${data.req.resultURL}" />
                      <input type="hidden" name="userType" value="${data.req.userType}" />
                      <input type="hidden" name="isMob" value="${true}" />
                    </form>
                  `);
                  document.querySelector("body").appendChild(form);

                  setTimeout(() => {
                    document.querySelector("#groupBuyingForm").submit();
                    return false;
                  }, 0);
                }
              } else {
                Toast(data.result.errormsg);
              }

              window.localStorage.removeItem("groupBuyingInvoice");
            })
            .catch(err => {
              console.log("err", err);
            });
        });
      };
      if (priceType != 3) {
        submitOrdersForm();
        return;
      }

      Dialog.confirm({
        title: `定金金额：￥${numFormat(Number(totalAmount) * (depositRatio / 100))}`,
        message: `拼单成功后，${paymentTimeLimit}小时内支付货款退还定金`,
        confirmButtonText: "确定",
        cancelButtonColor: "#999",
        confirmButtonColor: "#de181b"
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });

        submitOrdersForm();
      });
    },
    freightAmount() {
      const { data, goodsList, delivery } = this;
      if (delivery.deliveryId) {
        const goodsListFilter = goodsList.filter(item => item.quantity);

        /* 运费信息 */
        const goodsListArg = goodsListFilter.map(item => ({
          areaId: delivery.cityId, // 地区id
          goodsId: item.goodsId, // 商品id
          goodsPrice: item.amount, // 商品金额
          num: item.quantity, // 个数
          goodsMoney: this.totalAmount,
          refId: data.shopId, // 店铺id
          tId: item.shopFreightTemplateId, // 模板id
          weight: item.quantity, // 重量
          areaAxis: delivery.areaAxis // 地区编码
        }));

        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });

        toFreightAmountNew2({
          goodsList: JSON.stringify(goodsListArg)
        })
          .then(freightRes => {
            this.freightCharge = Number(Number(freightRes.GoodsFreightAmount).toFixed(4)).toFixed(
              2
            );
          })
          .finally(() => {
            Toast.clear();
          });
      }
    },
    compute() {
      const { priceType, goodsList = [] } = this;

      if (priceType == "1") {
        goodsList.forEach(item => {
          let e = true;
          let f = true;

          // 已经节省{{item.totalSpare}}元，预估到手价¥{{item.futurePrices}}元

          item.goodsLadderPriceList.forEach(item1 => {
            if (Number(item.quantity || 0) < item1.maxQuantity && e) {
              e = false;
              item.amount = item1.price;
            }
            if (Number(item1.maxQuantity) < 0 && e) {
              e = false;
              item.amount = item1.price;
            }
          });
          item.goodsLadderPriceList.forEach(item1 => {
            if (Number(item.quantity || 0) < item1.minQuantity && f) {
              item.showTips = false;
              // eslint-disable-next-line operator-linebreak
              const futureAmount =
                (Number(item.amount || 0) - Number(item1.price || 0)) * item1.minQuantity;
              item.futureAmount = Number(futureAmount.toFixed(2));
              item.futureQuantity = Number(
                (item1.minQuantity - Number(item.quantity || 0)).toFixed(item.goodsPriceDigit)
              );
              item.futurePrices = item1.price;

              f = false;
            }
            if (Number(item1.maxQuantity) < 0 && f) {
              console.log("2:", Number(item1.maxQuantity));
              f = false;
              item.showTips = true;
            }
          });

          // const [priceList] = item.goodsLadderPriceList.filter(
          //   priceItem => Number(item.quantity || 0) <= Number(priceItem.maxQuantity || 0)
          // );
          // item.amount = Number(
          //   Number(priceList.price) || item.goodsLadderPriceList[0].price
          // ).toFixed(4);

          // const maxPrice = item.goodsLadderPriceList[item.goodsLadderPriceList.length - 1];
          // const next = item.goodsLadderPriceList[priceList.level] || maxPrice;
          // if (priceList.level !== maxPrice.level) {
          //   item.futurePrices = next.price;
          // } else {
          //   item.futurePrices = maxPrice.price;
          // }
          // item.isMaxLevel = Number(item.quantity || 0) >= maxPrice.minQuantity;
          // const difference = item.goodsLadderPriceList[0].price - maxPrice.price;
          // item.totalSpare = (difference * item.quantity).toFixed(4);
          // const futureAmount = (Number(priceList.price || 0) - next.price) * Number(item.quantity);
          // item.futureAmount = futureAmount.toFixed(4);
          // item.futureQuantity = (next.minQuantity - Number(item.quantity)).toFixed(4);
        });
      }

      const goodsListFilter = this.goodsList.filter(item => item.quantity);

      this.$nextTick(() => {
        if (goodsListFilter.length) {
          const totalAmount = goodsListFilter.reduce(
            (cur, item) => cur + Number(item.amount) * Number(item.quantity),
            0
          );
          this.totalAmount = numFormat(Number(Number(totalAmount).toFixed(6)).toFixed(2));
        } else {
          this.totalAmount = "0.00";
        }

        if (priceType != 3) {
          this.freightAmount();
        }
      });
    },
    compareAddrChange() {
      const { data, goodsList, delivery } = this;
      const goodsId = goodsList.map(item => item.goodsId);
      /* 配送 */
      if (delivery.deliveryId) {
        compareAddr({
          shopId: data.shopId,
          goodsIds: goodsId.join(","),
          deliveryId: delivery.deliveryId
        }).then(res => {
          const { isCanBoolean } = res;
          if (isCanBoolean) {
            this.data.shippingType = 3;
          } else {
            this.data.shippingType = 2;
          }
        });
      }
    },
    isOriginalPrice(data) {
      const quantity = Number(data.quantity) + Number(data.joinCombinationOrderTotalCount);
      const minQuantity = Number(data.goodsLadderPriceList[0].minQuantity);
      if (quantity >= minQuantity) {
        return false;
      }

      return true;
    },
    agreement() {
      window.open("https://etp.nxin.com/notice/161201000421");
    },
    getLevel(data) {
      const { goodsLadderPriceList, joinCombinationOrderTotalCount = 0, quantity = 0 } = JSON.parse(
        JSON.stringify(data)
      );
      const total = Number(joinCombinationOrderTotalCount) + Number(quantity);
      const [price] = goodsLadderPriceList
        .reverse()
        .filter(item => total >= Number(item.minQuantity));

      if (price) {
        return price.level;
      }

      return "";
    },
    goGroupBuyingInvoice() {
      window.location.href = `${
        process.env.VUE_APP_APP
      }vm2/order/buyer/selectInvoice/index?groupBuyingInvoice=${JSON.stringify(
        this.groupBuyingInvoice
      )}`;
    }
  }
};
